import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  IMPORTANT_PERSON_FEATURE_KEY,
  ImportantPersonState,
  importantPersonAdapter,
} from './important-person.reducer';
import { selectParamPupilImportantPersonIds } from '../pupil/pupil.selectors';

export const selectImportantPersonState =
  createFeatureSelector<ImportantPersonState>(IMPORTANT_PERSON_FEATURE_KEY);

const { selectAll, selectEntities } = importantPersonAdapter.getSelectors();

export const selectAllImportantPersons = createSelector(
  selectImportantPersonState,
  (state: ImportantPersonState) => selectAll(state),
);

export const selectImportantPersonEntities = createSelector(
  selectImportantPersonState,
  selectEntities,
);

export const selectParamPupilImportantPersons = createSelector(
  selectParamPupilImportantPersonIds,
  selectAllImportantPersons,
  (importantPersonIds, importantPersons) =>
    importantPersonIds
      ? importantPersons.filter((importantPerson) =>
          importantPersonIds.includes(importantPerson.id),
        )
      : [],
);
